module.exports = __webpack_public_path__ + "img/BI.5364deaa.svg";